'use client';

import { usePathname } from 'next/navigation';
import { PropsWithChildren } from 'react';

const noFooterPages = ['/game/'];

export const FooterClientWrapper = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();

  if (noFooterPages.find((page) => pathname.includes(page))) return null;

  return children;
};
